<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import LocationsRoi from "@/view/components/locations/LocationROI.vue";
import LocationsReport from "@/view/components/locations/LocationsReport.vue";
import GroupsSummary from "@/view/components/locations/GroupSummary.vue";
import EditGroups from "@/view/components/locations/EditGroups.vue";



export default {
  name: "locations",
  components: {
    LocationsRoi,
    LocationsReport,
    GroupsSummary,
    EditGroups
  },
  data() {
    return {
      tab: ""
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    config() {
      return this.layoutConfig();
    }
  },
  watch: {
    $route: {
        immediate: true,
        handler(to, from) {
            document.title = to.meta.title || 'Aben';
        }
    }
  },
  async beforeMount() {
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Locations" }]);
    this.$store.commit("setLocationVisibile", false);
  },
  methods: {
    checkGroupSummary(){
      let componentEvent = this.$refs.groupsSummary 
      componentEvent.firstLoadDatePick();
      setTimeout(() => {
        componentEvent.searchLocations()
      }, 500);
    
    }
  }
};
</script>

<template>
  <div>
    <v-app>
      <v-main>
        <v-card>
          <v-container>
            <v-tabs v-model="tab">
              <v-tabs-slider></v-tabs-slider>
              <v-tab key="tab-1">Locations Summary</v-tab>
              <v-tab key="tab-2">Edit Locations</v-tab>
              <v-tab @click="checkGroupSummary" key="tab-3">Groups Summary</v-tab>
              <v-tab key="tab-4">Edit Groups</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item key="tab-1">
                <v-card color="basil" flat>
                  <locations-roi></locations-roi>
                </v-card>
              </v-tab-item>
              <v-tab-item key="tab-2">
                <v-card color="basil" flat>
                  <locations-report></locations-report>
                </v-card>
              </v-tab-item>
              <v-tab-item key="tab-3">
                <v-card color="basil" flat>
                  <groups-summary 
                    ref="groupsSummary"  
                  ></groups-summary>
                </v-card>
              </v-tab-item>
              <v-tab-item key="tab-4">
                <v-card color="basil" flat>
                  <edit-groups></edit-groups>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-container>
        </v-card>
      </v-main>
    </v-app>
  </div>
</template>

<style scoped>
button {
  position: absolute;
  right: 10px;
}
</style>
